
//import "signalr";
//import "@aspnet/signalr";
import signalR = require('@aspnet/signalr');
import * as Common_BUHub from "../Common/BUHub";
import { Components } from './Components';

export module Framework {

	export class SignalR {

		private static reconnectCount: number = 0;
		private static isConnected: boolean = false;

		public static async InitAllAsync(container?: JQuery): Promise<any> {

			window.BeatsUnion = window.BeatsUnion || {};
			window.BeatsUnion.BUHub = <Common_BUHub.Common.BUHub>(Components.getByElement($(".component#signalRHub")));

			var buHubComponent = (<Common_BUHub.Common.BUHub>window.BeatsUnion.BUHub);

			if (!SignalR.isConnected) {
				SignalR.connect("buHub", buHubComponent);
				SignalR.isConnected = true;
			}

			var elemList = container.find(".singlar-hub-component");

			$.each(elemList, async (i, e) => {

				var key = "signalr-eventList";
				var eventList: Array<any> = $.isArray($(e).data(key)) ? $(e).data(key) : [];

				for (var i = 0; i < eventList.length; i++) {

					var obj = eventList[i];
					buHubComponent.addHandler(obj.eventName, buHubComponent.cacheKey, (data) => {

						var callbackData = data;
						try {
							callbackData = JSON.parse(data);
						} catch (e) {

						}
						obj.callback(callbackData);
					});
				}
			});
		}


		private static connect(hubName: string, buHubComponent: Common_BUHub.Common.BUHub) {

			var connection = new signalR.HubConnectionBuilder()
				.withUrl(window.location.origin + "/" + hubName)
				.configureLogging(signalR.LogLevel.None)
				.build();

			var targetPrototype = Object.getOwnPropertyNames((<any>buHubComponent).__proto__);

			connection.onclose(() => SignalR.handleDisconnect(hubName, buHubComponent));
			connection.start().then(() => {

				targetPrototype.forEach((val, i) => {

					if (val.toLowerCase() !== "constructor")
						if ($.isFunction(buHubComponent[val]))
							connection.on(val, (...args) => buHubComponent[val].apply(buHubComponent, args));
				});

				SignalR.reconnectCount = 0;

			}).catch(() => {
				setTimeout(() => {

					if (SignalR.reconnectCount < 5) {
						//console.log("reconnecting");
						SignalR.reconnectCount += 1;
						SignalR.connect(hubName, buHubComponent);
					}
				}, 10 * 1000);
			});

		}

		private static handleDisconnect(hubName: string, buHubComponent: Common_BUHub.Common.BUHub) {
			//console.log("disconnected");
			SignalR.isConnected = false;

			window.setTimeout(() => SignalR.connect(hubName, buHubComponent), 10 * 1000);
		}

		private static printState(state) {
			var messages = $("#Messages");
			return ["connecting", "connected", "reconnecting", state, "disconnected"][state];
		}

		private static getQueryVariable(variable) {
			var query = window.location.search.substring(1),
				vars = query.split("&"),
				pair;
			for (var i = 0; i < vars.length; i++) {
				pair = vars[i].split("=");
				if (pair[0] == variable) {
					//return unescape(pair[1]);
					return pair[1];
				}
			}
		}
	}
}
